import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, inputCls } from "@/components/LegsEditor";
import { CLIENT_TYPES, JET_CARD_CATEGORIES, JET_PROGRAMS } from "@/lib/format";

export const ClientTypeFields = ({ value, onChange }) => {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div>
      <Field label="Client type">
        <div className="flex gap-2 flex-wrap" data-testid="client-type-tabs">
          {CLIENT_TYPES.map((c) => (
            <button type="button" key={c.value} onClick={() => set("clientType")(c.value)} data-testid={`client-type-${c.value}`}
              className={`frame-btn ${value.clientType === c.value ? "gold" : ""}`}>{c.label}</button>
          ))}
        </div>
      </Field>
      {value.clientType === "jet_card" && (
        <div className="lux-card p-4 sm:p-5 mt-4 grid sm:grid-cols-2 gap-5 rise" data-testid="jet-card-panel">
          <Field label="Jet Card program">
            <div className="flex gap-2 flex-wrap">
              {Object.entries(JET_PROGRAMS).map(([k, p]) => (
                <button type="button" key={k} onClick={() => set("program")(k)} data-testid={`jet-program-${k}`}
                  className={`px-4 h-11 text-[0.68rem] tracking-[0.2em] uppercase border transition-[opacity,box-shadow] ${p.cls} ${value.program === k ? "ring-2 ring-offset-2 ring-offset-[#0d0f14] ring-white" : "opacity-80 hover:opacity-100"}`}>
                  {p.label}
                </button>
              ))}
            </div>
          </Field>
          <Field label="Jet Card aircraft category">
            <Select value={value.jetCategory} onValueChange={set("jetCategory")}>
              <SelectTrigger className={inputCls} data-testid="jet-category-select"><SelectValue placeholder="Select category" /></SelectTrigger>
              <SelectContent>
                {JET_CARD_CATEGORIES.map((c) => <SelectItem key={c.value} value={c.value} data-testid={`jet-category-${c.value}`}>{c.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </Field>
        </div>
      )}
    </div>
  );
};

export const clientTypeError = (v) => {
  if (!v.clientType) return "Select the client type";
  if (v.clientType === "jet_card" && !v.program) return "Select the Jet Card program";
  if (v.clientType === "jet_card" && !v.jetCategory) return "Select the Jet Card aircraft category";
  return null;
};
